import React, {useState, useRef} from 'react';
import {MdKeyboardArrowDown} from 'react-icons/md';
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';

import styles from './styles.module.scss';
import {
  MenuRect,
  MenuServers,
  MenuLanguage,
  MenuChangelog,
  MenuSupport,
  MenuLogout,
  MenuEnglish,
  MenuFrench,
  MenuTurkey,
  MenuChinese,
  MenuDutch,
} from '../../assets';
import {routes} from '../../constants/routes';
import {useLogout} from '../../hooks/useAuth';
import {useOutsideClick} from '../../hooks/useOutsideClick';

const menu = [
  {
    id: '1',
    name: 'My servers',
    to: routes.chooseServer,
    icon: <MenuServers />,
  },
  {
    id: '2',
    name: 'Language',
    icon: <MenuLanguage />,
    list: [
      {
        id: '1',
        name: 'English',
        icon: <MenuEnglish />,
      },
      {
        id: '2',
        name: 'Français',
        icon: <MenuFrench />,
      },
      {
        id: '3',
        name: 'Türkçe',
        icon: <MenuTurkey />,
      },
      {
        id: '4',
        name: '中国',
        icon: <MenuChinese />,
      },
      {
        id: '5',
        name: 'Dutch',
        icon: <MenuDutch />,
      },
    ],
  },
  {
    id: '3',
    name: 'Changelog',
    to: routes.changelog,
    icon: <MenuChangelog />,
  },
  {
    id: '4',
    name: 'Support Server',
    to: routes.chooseServer,
    icon: <MenuSupport />,
  },
  {
    id: '5',
    name: 'Logout',
    icon: <MenuLogout />,
  },
];

export const ProfileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {logout} = useLogout();
  const menuRef = useRef(null);
  useOutsideClick(menuRef, () => setIsOpen(false));
  const {currentUserGlobalState} = useSelector((state) => state.currentUser);

  const handleChanges = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.wrapper} ref={menuRef}>
      <div className={styles.imageWrapper}>
        <div className={styles.image}>
          <img src={currentUserGlobalState?.data?.avatarURL} alt="avatar" />
        </div>
        <div className={`${styles.close} ${isOpen && styles.active}`} onClick={handleChanges}>
          <MdKeyboardArrowDown color={'#000'} />
        </div>
      </div>
      <div className={styles.menuWrapper}>
        {isOpen && (
          <div className={styles.back}>
            <MenuRect />
            <div className={styles.menu}>
              <div className={styles.top}>
                <p className={styles.name}>{currentUserGlobalState?.data?.globalName}</p>
                <div className={styles.label}>{currentUserGlobalState?.data?.usernameL}</div>
              </div>
              <div className={styles.list}>
                {menu.map((item) => {
                  return <MenuItem key={item.id} item={item} logout={logout} />;
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const MenuItem = ({item, logout}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleChanges = () => {
    setIsOpen(!isOpen);
  };

  if (item.to) {
    return (
      <Link key={item.id} className={styles.item} to={item.to}>
        <div className={styles.icon}>{item.icon}</div>
        <div className={styles.name}>{item.name}</div>
      </Link>
    );
  }
  if (item.list) {
    return (
      <div key={item.id} className={styles.item} onClick={handleChanges}>
        <div className={styles.icon}>{item.icon}</div>
        <div className={styles.name}>{item.name}</div>
        {isOpen && (
          <div className={styles.subList}>
            {item.list.map((el) => (
              <div key={el.id} className={`${styles.item} ${styles.subItem}`}>
                <div className={`${styles.icon} ${styles.subIcon}`}>{el.icon}</div>
                <div className={`${styles.name} ${styles.subName}`}>{el.name}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
  return (
    <div key={item.id} className={styles.item} onClick={logout}>
      <div className={styles.icon}>{item.icon}</div>
      <div className={styles.name}>{item.name}</div>
    </div>
  );
};
